import { Navigate } from 'react-router';
import { useAuth } from '../AuthContext.tsx';

export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}
